<template>
  <div id="leftLevelNavigation">
    <div @click="changeNav(item)" :class="[
      'leftLevelNavigation-item',
      navId == item.id ? 'leftLevelNavigation-item-active' : '',
    ]" v-for="item in navigation" :key="item.id">
      <img :src="navId == item.id ? item.iconActive : item.icon" alt="" />
      <span>{{ item.name }}</span>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      navigation: [
        {
          id: 1,
          path: "/",
          name: "数据总览",
          icon: require("@/assets/images/n1.png"),
          iconActive: require("@/assets/images/na1.png"),
          className: "leftLevelNavigation-img1",
          arrPath: ["/"],
        },
        {
          id: 2,
          path: "/programmeManagement",
          name: "方案管理",
          icon: require("@/assets/images/n2.png"),
          iconActive: require("@/assets/images/na2.png"),
          className: "leftLevelNavigation-img2",
          arrPath: ["/programmeManagement"],
        },
        {
          id: 5,
          path: "/collectionManagement",
          name: "收藏管理",
          icon: require("@/assets/images/n5.png"),
          iconActive: require("@/assets/images/na5.png"),
          className: "leftLevelNavigation-img2",
          arrPath: ["/collectionManagement"],
        },
        {
          id: 3,
          path: "/modelManagement",
          name: "模型管理",
          icon: require("@/assets/images/n3.png"),
          iconActive: require("@/assets/images/na3.png"),
          className: "leftLevelNavigation-img3",
          arrPath: ["/modelManagement", "/modelBinding"],
        },
        {
          id: 4,
          path: "/helpRecord",
          name: "帮助管理",
          icon: require("@/assets/images/n4.png"),
          iconActive: require("@/assets/images/na4.png"),
          className: "leftLevelNavigation-img3",
          arrPath: ["/helpRecord"],
        },
      ],
      navId: 1,

      area: Number(localStorage.getItem('region')), //地区：1=中国，2=其他
    };
  },
  mounted() {
    this.navigation.forEach((v) => {
      if (v.arrPath.indexOf(this.$route.path) != -1) {
        this.navId = v.id;
      }
    });
  },
  methods: {
    changeNav(item) {
      if (this.$route.path == item.path) {
        return false;
      }
      this.navId = item.id;
      this.$router.push(`${item.path}`);
    },
  },
  watch: {
    $route: {
      handler(val) {
        this.navigation.forEach((v) => {
          if (v.arrPath.indexOf(val.path) != -1) {
            this.navId = v.id;
          }
        });

        if (val.fullPath == '/modelManagement' || val.fullPath == '/helpRecord') {
          this.area = 2
        } else if (val.fullPath == '/' || val.fullPath == '/programmeManagement' || val.fullPath == '/collectionManagement') {
          this.area = 1
        }
      },
      deep: true,
    },
    area: {
      handler(newVal) {
        if (localStorage.getItem('region') != newVal) {
          this.$store.dispatch('updateGlobalVar', newVal);
          window.location.reload();
        }
      },
      deep: true
    }
  },
};
</script>
<style lang="scss" scoped>
#leftLevelNavigation {
  width: 250px;
  height: calc(100vh - 80px);
  background-color: #fff;

  .leftLevelNavigation-item {
    display: flex;
    align-items: center;
    padding-left: 49px;
    height: 50px;
    cursor: pointer;

    >img {
      width: 18px;
      height: auto;
      margin-right: 17px;
    }

    >span {
      font-size: 16px;
      color: #444444;
    }
  }

  .leftLevelNavigation-item-active {
    background-color: #e64a19;

    >span {
      color: #fff;
    }
  }
}
</style>